'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = inputFilter;
function inputFilter(value, previousValue, type) {

    type = type && type.toUpperCase();
    if (type === 'DECIMAL' || type === 'MONEY') {
        var finalValue = value.replace(/[^0-9.,]/g, '').replace(',', '.');
        var decimal = finalValue.lastIndexOf('.');
        var preDecimal = finalValue.indexOf('.');

        if (decimal !== -1) {
            if (type === 'MONEY') {

                if (finalValue.substring(decimal).length > 3) {
                    finalValue = '' + finalValue.substring(0, decimal + 2) + finalValue[finalValue.length - 1];
                }
                if (finalValue.substring(decimal).length === 2) {
                    if (finalValue.length > previousValue.length) {

                        finalValue = finalValue + '0';
                    }
                }
            }
            if (decimal !== preDecimal) {
                var finalValueAsCharArr = finalValue.split('');
                finalValueAsCharArr.splice(preDecimal, 1);
                finalValue = finalValueAsCharArr.join('');
            }
        }
        return finalValue;
    } else if (type === "NUMBER") {
        return value.replace(/[^0-9]/g, "");
    } else if (type === "PERCENTAGE") {
        value = value.replace(/[^0-9]/g, '');
        if (parseInt(value) > 100) {
            return '100';
        }
    } else if (type === 'EMAIL') {
        value = value.toLowerCase();
    }

    return value;
}